import React from 'react';
import pdf from './CV/Resume.pdf';

function HireMe() {
//   const handleDownload = async () => {
//     const filename = 'MohamedCv_Frensh.pdf';

//     try {
//     //   const response = await fetch('http://127.0.0.1:8081/' + filename);
//       const response = await fetch('http://127.0.0.1:8081/' + filename);
//       const blob = await response.blob();
//       console.log(response.status);
//       console.log(blob.size);
//       const blobUrl = window.URL.createObjectURL(blob);
//       console.log(blob)
//       const aTag = document.createElement('a');
//       aTag.href = blobUrl;
//       console.log(aTag)
//       aTag.setAttribute('download', filename);
//       document.body.appendChild(aTag);
//       aTag.click();
//       document.body.removeChild(aTag);
//       window.URL.revokeObjectURL(blobUrl);
//     } catch (error) {
//       console.error('Error downloading file:', error);
//     }
//   };

const handleDownload = async () => {
    const filename = 'Resume.pdf';

    try {
    //   const response = await fetch('http://127.0.0.1:8080/' + filename);
      const response = await fetch(pdf);
      console.log(response);
      const blob = await response.blob();
      console.log(response.status);
      console.log(blob.size);
      console.log(blob);
      const blobUrl = window.URL.createObjectURL(blob);
      console.log(blob)
      const aTag = document.createElement('a');
      aTag.href = blobUrl;
      console.log(aTag)
      aTag.setAttribute('download', filename);
      document.body.appendChild(aTag);
      aTag.click();
      document.body.removeChild(aTag);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  return (
    <button className="hireme" onClick={handleDownload}>
      Hire Me<span className="hire"><span className="material-symbols-outlined">upload_file</span></span>
    </button>
  );
}

export default HireMe;